export default __webpack_public_path__ + "static/media/green_icon.6ab9269d.svg";